/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useState, useEffect, useRef } from "react";
import { Input } from "@coreai/component-library";
import { useTheme } from "@emotion/react";
import { useOutsideAlerter } from "../../../hooks/useOutsideAlerter";

interface AutocompleteProps {
    data: string[];
    setAutocompleteValue: (value: string) => void;
    focuseNext: () => void;
    autocompleteValue?: string;
    autocompleteLable?: string;
    autocompletePlaceholder?: string;
    addnewButtonPrefix?: string;
    props?: any;
}

export default function Autocomplete(
  props: Readonly<AutocompleteProps>
) {
  const theme = useTheme();
  const [inputValue, setInputValue] = useState(props?.autocompleteValue);
  const [filteredList, setFilteredList] = useState<string[]>([]);

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const dropdownWraperRef = React.createRef<HTMLDivElement>();
  const [outsideSideMenu] = useOutsideAlerter(dropdownWraperRef);
 const listRef = useRef<(HTMLLIElement | null)[]>([]);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  useEffect(() => {
    if (showDropdown) {
      setShowDropdown(false);
    }
  }, [outsideSideMenu]);

  const dropdownStyles = css`
    position: absolute;
    background-color: white;
    border: 1px solid ${theme.colors.strokeGray};
    border-top: none;
    border-radius: 0 0 ${theme.radius.xs} ${theme.radius.xs};
    width: 100%;
    z-index: 1000;
    box-shadow: ${theme.shadows.medium};
    .suggestion-item, .suggest-new {
      background-color: transparent;
    }
    .suggestion-item:hover, .suggest-new:hover {
      background-color: #f0f0f0;
    }
  `;

  const suggestionsContainerStyles = {
    maxHeight: "150px",
    overflowY: "auto",
  } as React.CSSProperties;

   const dropdownItemHoverStyles = {
    backgroundColor: "#f0f0f0",
    padding:'8px',
  };
  const dropdownItemStyles = {
    padding: theme.spacing.md,
    fontFamily: theme.typography.bodyMedium.fontFamily,
    fontSize: theme.typography.bodyMedium.fontSize,
    fontWeight: theme.typography.bodyMedium.fontWeight,
    lineHeight: theme.typography.bodyMedium.lineHeight,
    color: theme.colors.textMedium,
    cursor: "pointer",
  } as React.CSSProperties;

  const addNewbuttonStyles = {
    padding: theme.spacing.md,
    borderRadius: `0 0 ${theme.radius.xs} ${theme.radius.xs} `,
    cursor: "pointer",
    color: theme.colors.primary,
    borderBottom: theme.radius.xs,
    backgroundColor: theme.colors.white,
  } as React.CSSProperties;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const newFilteredlist = props.data.filter((item) => item.toLowerCase().includes(value.toLowerCase()));
    setFilteredList(newFilteredlist);
    setInputValue(value);
    props.setAutocompleteValue(value);
    setShowDropdown(true);
  };

  const handleSuggestionClick = (suggestion: string) => {
    setInputValue(suggestion);
    setShowDropdown(false);
    props.setAutocompleteValue(suggestion);
  };

  const handleAddClick = () => {
    setShowDropdown(false);
    props.focuseNext();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
      if (!showDropdown) return;
      let keyName = e?.key?.toLocaleLowerCase();
      if (keyName === "arrowdown") {
        e.preventDefault();
         setActiveIndex((prev) => (prev + 1) % filteredList?.length);       
      } else if (keyName === "escape") {
        e.preventDefault();
        setShowDropdown(false);
      }else if (keyName === "arrowup") {
        e.preventDefault();
         setActiveIndex((prev) => (prev - 1 + filteredList?.length) % filteredList?.length);
      } else if (keyName === "enter") {
        if (activeIndex >= 0) {
          setInputValue(filteredList[activeIndex]);
          props.setAutocompleteValue(filteredList[activeIndex]);
          setShowDropdown(false);
        }
      }
    };
  useEffect(() => {
      if (activeIndex >= 0 && listRef.current[activeIndex]) {
        listRef.current[activeIndex]?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, [activeIndex]);

  return (
    <div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
      <Input
        type="text"
        label={props?.autocompleteLable || ""}
        placeholder={props?.autocompletePlaceholder || ""}
        value={inputValue || ""}
        onChange={handleInputChange}
        onFocus={(e) => {
          setShowDropdown(true)
          handleInputChange(e)
        }}
        autoComplete="off"
        aria-required="true"
        {...props.props}
        required
      />

      {showDropdown && (
        <div onKeyDown={handleKeyDown} tabIndex={0} ref={dropdownWraperRef} css={dropdownStyles}>
          <ul style={suggestionsContainerStyles}>
            {filteredList
              .map((suggestion,idx) => (
                <li
                  ref={(el) => (listRef.current[idx] = el)}
                  className="suggestion-item"
                  style={idx === activeIndex ? dropdownItemHoverStyles : dropdownItemStyles}
                  key={`${suggestion}-${idx}` }
                  // style={dropdownItemStyles}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </li>
            ))}
          </ul>
         {(!filteredList?.length && inputValue) &&  <div
              className="suggest-new"
              style={addNewbuttonStyles}
              onClick={handleAddClick}
            >
                {props?.addnewButtonPrefix || ""} {`"${inputValue}"`}
            </div>
         }
        </div>
      )}
    </div>
  );
}
